// src/services/firestoreService.js

import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../app/firebase';

/**
 * Browser region (ISO 3166-1 alpha-2) from locale — not IP/GPS.
 * @return {string|null}
 */
function getBrowserRegionCode() {
  try {
    const tag =
      (typeof Intl !== 'undefined' &&
        Intl.DateTimeFormat?.().resolvedOptions?.().locale) ||
      (typeof navigator !== 'undefined' && navigator.language) ||
      '';
    if (typeof Intl !== 'undefined' && typeof Intl.Locale === 'function' && tag) {
      const region = new Intl.Locale(tag).region;
      if (typeof region === 'string' && /^[A-Za-z]{2}$/.test(region)) {
        return region.toUpperCase();
      }
    }
    const parts = String(tag).replace(/_/g, '-').split('-');
    for (let i = parts.length - 1; i >= 0; i -= 1) {
      if (/^[A-Za-z]{2}$/.test(parts[i]) && parts[i] === parts[i].toUpperCase()) {
        return parts[i].toUpperCase();
      }
      // en-us → US
      if (/^[A-Za-z]{2}$/.test(parts[i]) && i > 0) {
        return parts[i].toUpperCase();
      }
    }
  } catch {
    // ignore
  }
  return null;
}

/**
 * Создаёт или обновляет документ пользователя в Firestore.
 * Аккуратно добавляет createdAt только для новых пользователей, не изменяя существующих.
 * @param {object} user - Объект Firebase user
 */
export const createUserInFirestore = async (user) => {
  if (!user) {
    console.error("createUserInFirestore: user is null or undefined");
    return;
  }

  const userRef = doc(db, 'users', user.uid);

  try {
    // Проверяем, существует ли документ и есть ли у него createdAt
    const userDoc = await getDoc(userRef);
    const userData = userDoc.exists() ? userDoc.data() : null;
    const hasCreatedAt = userData?.createdAt !== undefined;

    // Подготавливаем данные для сохранения
    const dataToSave = {
      email: user.email,
      name: user.displayName || '', // Use displayName from Google if available
      telegramChatId: null,
      plan: 'Free',
    };

    // Добавляем createdAt только если его еще нет (для новых пользователей)
    // Это безопасно для продакшена - не изменяет существующих пользователей
    if (!hasCreatedAt) {
      dataToSave.createdAt = serverTimestamp();
      dataToSave.signupPlatform = 'web';
      const signupCountry = getBrowserRegionCode();
      if (signupCountry) {
        dataToSave.signupCountry = signupCountry;
      }
    }

    // Используем merge: true для безопасного обновления существующих пользователей
    await setDoc(userRef, dataToSave, { merge: true });
  } catch (error) {
    console.error("createUserInFirestore: Error creating user document:", error);
    throw error; // Re-throw to let caller handle it
  }
};
